import { useEffect } from "react";

import SEO from "seo/SEO";
import { AlbumsPage } from "templates";
import { scrollToTop } from "utils/utilities";

function Albums() {
  useEffect(() => {
    scrollToTop(window)
  }, [])

  return (
    <>
      <SEO
        title="Albums | Vasudev College Of Law, Haldwani"
        description="Albums of Vasudev College Of Law, Haldwani"
        keywords="Albums Vasudev College Of Law, Gallery Vasudev College Of Law"        
      />  
      <AlbumsPage/>      
    </>
  )
}

export default Albums;